export default __webpack_public_path__ + "static/media/select-course.faf5d2d4.svg";